/**
 * Convert Arabic-Indic numerals to Western numerals
 * @param {string} text - Text containing Arabic-Indic numerals
 * @returns {string} - Text with Western numerals
 */
export const arabicToEnglish = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  
  const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  
  let result = text;
  arabicNumbers.forEach((arabic, index) => {
    result = result.replace(new RegExp(arabic, 'g'), englishNumbers[index]);
  });
  
  return result;
};

/**
 * Handle input change and convert Arabic numerals to English
 * @param {Event} e - Input event
 * @param {Function} onChange - Original onChange handler
 */
export const handleNumberInput = (e, onChange) => {
  const value = e.target.value;
  const convertedValue = arabicToEnglish(value);
  
  if (value !== convertedValue) {
    // Create a new event with converted value
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: convertedValue,
      },
    };
    onChange(syntheticEvent);
  } else {
    onChange(e);
  }
};


